<template>

  <!-- <div v-if="userProfile.userId && isFriend">
    <p>友情狀態:</p>
    {{  isFriend }}
    <p>使用者資訊:</p>
    {{  userProfile }}
  </div> -->

  <div class="absoluteFlexCenter">
    <div class="spinner-border text-primary bg" style="width: 3rem; height: 3rem;" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
    <div class="spinner-bg absoluteFlexCenter"><logo /><svg width="40" height="40"><use xlink:href="#logo"/></svg></div>
  </div>
  <div class="absoluteFlexCenter small text-gray text-center fst-italic px-3" style="margin-top:56px;" v-html="randomQuote"></div>

</template>

<script>
import liff from '@line/liff';
import axios from 'axios';
import { mapActions, mapGetters } from 'vuex';
import logo from '@/components/IconLogo.vue';
import { SubscriptionStatus } from '@/utils/setup.js';
import { getRandomQuote } from '@/utils/quoteService'

let api_url = process.env.VUE_APP_API_URL;
let liff_id = process.env.VUE_APP_LIFF_ID;
let liff_callback = process.env.VUE_APP_LIFF_CALLBACK;
let ad_manager_click_url = process.env.VUE_APP_AD_MANAGER_CLICK_URL;


export default {
  name: 'MeView',
  components: { logo },
  data () {
    return {
      userProfile: {
        userId: '',
        displayName: '',
        pictureUrl: '',
        email: ''
      },
      isFriend: false,
        routeParams: {
        page: null,
        tab: null,
        adId: null,
        targetUrl: null,
        type: null,
        fid: null
      },
      randomQuote: '載入中...'
    }
  },

  computed: {
    ...mapGetters(['token', 'refresh_token', 'userId'])
  },
  
  async mounted() {
    this.randomQuote = await getRandomQuote()
    const params = this.parseRouteParams();

    if (params.hasError) {
      console.log('用戶拒絕了授權請求。');
      this.$router.replace('/');
      return;
    }

    try {
      await liff.init({ liffId: liff_id });

      if (!liff.isLoggedIn()) {
        return this.handleLogin();
      }

      await this.getUserProfile();

      if (params.adId && params.targetUrl) {
        this.handleAdClick(params.adId, params.targetUrl);
        return;
      }

      if (params.page === 'luckywheel') {
        let idToken = liff.getIDToken();
        const res = await this.register(idToken);

        if(res) {
          if (params.sid) {
            this.$router.replace(`/luckywheel?sid=${params.sid}`);
          } else {
            this.$router.replace('/luckywheel');
          }
        } else {
          console.log('idToken 可能已經過期');
          this.clearToken();
          liff.logout();
          setTimeout(() => {
            this.handleLogin();
          }, 500);
        }

        
        return;
      }

      try {
        this.isFriend = await this.getFriendship(this.userProfile.userId);

        if (!this.isFriend) {
          alert('請先加入好友或解除封鎖小美秘書，才能使用本服務喔！');
          console.log('用戶不想跟你交朋友。');
          this.$router.replace('/');
          return;
        }

        const idToken = liff.getIDToken();

        const res = await this.register(idToken);

        if (res) {
          let status = await this.getSubscriptionStatus();

          // Active 狀態包含：正常訂閱(NORMAL)和已取消但仍有效(CANCEL)
          if (status['main'] == SubscriptionStatus.ACTIVE) {
            // 如果試圖進入訂閱頁面，提示已經訂閱
            if (params.page === 'plan') {
              if (status['sub'] === 'CANCEL') {
                // 已取消但仍有效，允許進入訂閱頁面重新訂閱
                this.$router.replace('/plan');
              } else {
                // 正常訂閱中，不允許重複訂閱
                alert('您已經訂閱過了！可以開始使用囉！');
                this.$router.replace('/main');
              }
              return;
            }

            // 根據參數導航到相應頁面
            if (params.tab === '會員資訊' || params.page === 'plan') {
              this.$router.replace('/main?tab=會員資訊');
            } else if (params.tab === '分析報告') {
              this.$router.replace('/main?tab=分析報告');
            } else if (params.page=== 'share_management') {
              this.$router.replace('/share_management');
            } else {
              this.$router.replace('/main');
            }
            return;

          } else if (status['main'] == SubscriptionStatus.PENDING_ACTIVATION) {
            // 免費用戶，允許正常進入各個頁面
            // 根據參數導航到相應頁面
            if (params.page === 'plan') {
              this.$router.replace('/plan');
            } else if (params.tab === '會員資訊') {
              this.$router.replace('/main?tab=會員資訊');
            } else if (params.tab === '分析報告') {
              this.$router.replace('/main?tab=分析報告');
            } else if (params.page === 'share_management') {
              this.$router.replace('/share_management');
            } else {
              // 如果訂單數量超過限制，帶上參數提示用戶
              if (status['sub'] === 'ORDER_LIMIT_EXCEEDED') {
                this.$router.replace('/main?quota_exceeded=true');
              } else {
                this.$router.replace('/main');
              }
            }
            return;
          } else if (status['main'] == SubscriptionStatus.PENDING_RENEWAL) {
            // 待續訂狀態：用戶可以繼續使用服務到原本的 EndDate
            // 根據參數導航到相應頁面，不強制進入會員資訊頁面
            
            // 如果用戶想要進入訂閱頁面，允許（可能想重新訂閱或查看方案）
            if (params.page === 'plan') {
              this.$router.replace('/plan');
            } else if (params.tab === '會員資訊') {
              this.$router.replace('/main?tab=會員資訊');
            } else if (params.tab === '分析報告') {
              this.$router.replace('/main?tab=分析報告');
            } else if (params.page=== 'share_management') {
              this.$router.replace('/share_management');
            } else {
              this.$router.replace('/main');
            }
            return;
          } else if (status['main'] == SubscriptionStatus.BANNED) {
            this.$router.replace('/disabled');
            return;
          } else {
            // Expired 或其他狀態
            // 檢查是否因訂單數量超過限制
            if (status['sub'] === 'ORDER_LIMIT_EXCEEDED') {
              // 允許正常進入各個頁面
              if (params.page === 'plan') {
                this.$router.replace('/plan');
              } else if (params.tab === '會員資訊') {
                this.$router.replace('/main?tab=會員資訊');
              } else if (params.tab === '分析報告') {
                this.$router.replace('/main?tab=分析報告');
              } else if (params.page === 'share_management') {
                this.$router.replace('/share_management');
              } else if (params.page === 'order_confirm') {
                this.$router.replace({
                  path: '/confirm',
                  query: {
                    orderId: params.orderId,
                    transactionId: params.transactionId
                  }
                });
              } else {
                // 預設進入主頁面，帶上超額提示參數
                this.$router.replace('/main?quota_exceeded=true');
              }
              return;
            }
            
            // 其他 Expired 狀態（訂單未超過限制）或未知狀態
            // 允許用戶正常進入各個頁面，自行決定是否重新訂閱
            if (params.page === 'plan') {
              this.$router.replace('/plan');
            } else if (params.tab === '會員資訊') {
              this.$router.replace('/main?tab=會員資訊');
            } else if (params.tab === '分析報告') {
              this.$router.replace('/main?tab=分析報告');
            } else if (params.page === 'share_management') {
              this.$router.replace('/share_management');
            } else if (params.page === 'order_confirm') {
              this.$router.replace({
                path: '/confirm',
                query: {
                  orderId: params.orderId,
                  transactionId: params.transactionId
                }
              });
            } else {
              // 預設進入主頁面（訂單管理），讓用戶自行決定是否訂閱
              this.$router.replace('/main');
            }
            return;
          }
        } else {
          console.log('idToken 可能已經過期');
          this.clearToken();
          liff.logout();
          setTimeout(() => {
            this.handleLogin();
          }, 500);
        }

      } catch(error) {
        console.error('unknow friendship', error);
        this.$router.replace('/');
        return;
      }

    } catch(error) {
      console.error('Check login failed:', error);
      liff.logout();
      setTimeout(() => {
        this.handleLogin();
      }, 500);
    }
  },
  methods: {

    ...mapActions(['setToken', 'clearToken', 'setRefreshToken', 'clearRefreshToken', 'setUserId', 'clearUserId', 'setEmail', 'clearEmail', 'setName', 'clearName', 'setPictureUrl']),

    parseRouteParams() {
      const urlParams = new URLSearchParams(window.location.search);
      const hasError = urlParams.has('error') && 
                      urlParams.get('error').toLowerCase() === 'access_denied';

      this.routeParams = {
        page: this.$route.query.page,
        tab: this.$route.query.tab,
        adId: urlParams.get('ad_id'),
        targetUrl: urlParams.get('target_url'),
        type: urlParams.get('type'),
        sid: urlParams.get('sid'),
        hasError,
        orderId: this.$route.query.orderId,
        transactionId: this.$route.query.transactionId
      };
      return this.routeParams;
    },

    async handleLogin() {
      try {
        // Clear tokens
        this.clearToken();
        this.clearRefreshToken();
        this.clearUserId();
        this.clearEmail();
        this.clearName(); 
        
        // Use centralized parameters
        const params = this.routeParams;
        const redirectUri = new URL(liff_callback);

        // Add non-null parameters to redirect URL
        Object.entries(params).forEach(([key, value]) => {
          if (value) {
            // Convert camelCase to snake_case for URL parameters
            const urlKey = key.replace(/[A-Z]/g, letter => `_${letter.toLowerCase()}`);
            redirectUri.searchParams.append(urlKey, value);
          }
        });

        return liff.login({ redirectUri: redirectUri.toString() });
        
      } catch (error) {
        console.error('Login failed:', error);
        return liff.login();
      }
    },

    async getUserProfile() {
      // 取得使用者資料
      let profile = await liff.getProfile();
      this.userProfile.userId = profile.userId;
      this.userProfile.displayName = profile.displayName;
      this.userProfile.pictureUrl = profile.pictureUrl;
      // 嘗試取得 email
      const user = liff.getDecodedIDToken();
      if (user.email) {
        this.userProfile.email = user.email;
        this.setEmail(user.email);
      }
      // 嘗試取得頭貼連結
      if (profile.pictureUrl) {
        this.setPictureUrl(profile.pictureUrl);
      }
      // 記錄暱稱
      this.setName(profile.displayName);
      this.setUserId(profile.userId);
    },

    async getFriendship(user_id) {
      try {

        const baseURL = `${api_url}/get_friendship`;

        const response = await axios.post(baseURL, {
          user_id: user_id
        });
        
        console.log(response.data);
        console.log(response.data.status);
        if (response.data.status == 'follow') {
          return true;
        } else {
          return false;
        }
      } catch (error) {
        console.error("Error getFriendship:", error);
        return false
      }
      
    },

    startCheckingFriendship() {
      this.checkInterval = setInterval(() => {
        liff.getFriendship().then((data) => {
          this.isFriend = data.friendFlag;
          if (this.isFriend) {
            // 如果已加入好友，您可以停止檢查或執行其他操作
            clearInterval(this.checkInterval);
          }
        });
      }, 3000); // 每3秒鐘檢查一次
    },

    async verifyToken(accessToken) {
        try {
            const response = await fetch(`https://api.line.me/oauth2/v2.1/verify?access_token=${accessToken}`);
            const data = await response.json();

            if (data.client_id && data.expires_in) {
                console.log("Token is valid");
                return true;
            } else {
                console.log("Token is invalid or expired");
                await this.handleTokenError();
                return false;
            }
        } catch (error) {
            console.error("Error verifying token:", error);
            await this.handleTokenError();
            return false;
        }
    },

    async handleTokenError() {
      this.clearToken();
      this.clearRefreshToken();
      this.clearUserId();
      liff.logout();
      setTimeout(() => {
        this.handleLogin();
      }, 500);
    },

    async register(idToken) {
        try {
          const baseURL = `${api_url}/user_register`;

          const response = await axios.post(baseURL, {
              idToken: idToken
          });

          if (response.data.result == "OK") {
            this.setToken(response.data.token);
            this.setRefreshToken(response.data.refresh_token);
            return true;
          } else {
            return false;
          }
        } catch (error) {
          console.error('Error sending POST request:', error);
          return false;
        }
    },

    async getSubscriptionStatus() {

/*       return {
        main: SubscriptionStatus.ACTIVE,
        sub: ''
      } */
      //TODO: 這裡要改成真的 API
      try {
        const baseURL = `${api_url}/v1/users/${this.userId}/subscription_status`;

        const response = await axios.get(baseURL, {
          headers: {
            'Authorization': `Bearer ${this.token}`,
            "ngrok-skip-browser-warning": "69420"
          }
        });

        console.log(response.data);

        return response.data

      } catch (error) {
        console.error('Error sending GET request:', error);
        return false;
      }
    },

    handleAdClick(adId, targetUrl) {
      const clickUrl = `${ad_manager_click_url}`;
      const clickData = JSON.stringify({
        user_id: this.userId,
        ad_id: adId
      });

      if (this.isDesktop()) {
        // 桌面版使用 axios
        axios.post(clickUrl, JSON.parse(clickData), {
          headers: {
            'Content-Type': 'application/json',
            'ngrok-skip-browser-warning': '69420'
          }
        }).then(() => {
          window.location.href = targetUrl;
        }).catch(error => {
          console.error('Error recording ad click:', error);
          window.location.href = targetUrl;
        });
      } else {
        // 移動版使用 sendBeacon
        const blob = new Blob([clickData], {type: 'application/json'});
        navigator.sendBeacon(clickUrl, blob);
        if (liff && liff.isInClient()) {
          liff.openWindow({ url: targetUrl, external: true });
        } else {
          window.location.href = targetUrl;
        }
      }
    },

    isDesktop() {
      return !(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent));
    }


  }
}


/* app.config.globalProperties.$liff = liff;

app.config.globalProperties.$checkingLiffEnv = function() {
  if (liff.getOS() === "ios" || liff.getOS() === "android") {

    // 檢查是否在手機版的 LINE 內部
    if (liff.isInClient()) {
        
      return true;

    } else {
        // 顯示錯誤訊息或重新導向到其他頁面
        alert("請您在手機版的 LINE 內部進行訂閱喔！");
        // 使用 URL scheme 打開 LINE 並與官方帳號對話
        const lineUrl = `line://ti/p/@xiaomei`;
        window.location.href = lineUrl;

        // 設定一個短暫的延遲，然後檢查是否仍然在當前頁面
        setTimeout(() => {
            if (document.hasFocus()) {
                // 如果仍然在當前頁面，將使用者重新導向到另一個首頁
                this.$router.push('/');
            }
        }, 1000); // 這裡設定 1 秒的延遲，你可以根據需要調整
        
    }
  } else {
    // 不在 LINE 內部，顯示錯誤訊息或重新導向到其他頁面
    alert("請您在手機版的 LINE 內部進行訂閱喔！");
    this.$router.push('/');
  }
} */
</script>

